import { render, staticRenderFns } from "./CaseMedicationList.vue?vue&type=template&id=71c4a75a&scoped=true&"
import script from "./CaseMedicationList.vue?vue&type=script&lang=js&"
export * from "./CaseMedicationList.vue?vue&type=script&lang=js&"
import style0 from "./CaseMedicationList.vue?vue&type=style&index=0&id=71c4a75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c4a75a",
  null
  
)

export default component.exports